import React from "react"
import classes from "./Search.module.scss"
import icon from "../../../assets/icons/search-field-icon-blue.svg"

interface ISearchProps {
  onChange?: any
  value?: string
  size?: "lg" | "md" | "sm" | undefined
  className?: string
}

function Search({onChange, value, size = "md", className}: ISearchProps) {

  const cls: string[] = [classes.input]
  const wrapClasses = [classes.wrap]

  if (className){
    wrapClasses.push(className)
  }

  if (size) {
    cls.push(classes[`input_size_${size}`])
  }

  return (
    <div className={wrapClasses.join(" ")}>
      <img className={classes.icon} src={icon} alt={"search-icon"}/>
      <input
        className={cls.join(" ")}
        type="text"
        value={value}
        placeholder={"Поиск"}
        onChange={onChange}
      />
    </div>
  )
}

export default Search